module.exports = __webpack_public_path__ + "img/btnincell-plus-m.4379e84c.svg";